<template>
  <base-dialog width="485px" class="add-new-participant-dialog" :visible.sync="visible" show-close>
    <template v-slot:header>
      {{ title || "选择人员" }}
    </template>
    <el-form>
      <el-form-item label="请选择">
        <user-selector
          v-model="selected"
          v-bind="$attrs"
          @select="selectedUser = $event"
        ></user-selector>
      </el-form-item>
    </el-form>
    <template v-slot:footer>
      <base-button @click="visible = false">取消</base-button>
      <base-button type="primary" @click="submit">确认</base-button>
    </template>
  </base-dialog>
</template>

<script>
import BaseDialog from "@/components/BaseComponents/Dialog"
import BaseButton from "@/components/UIComponents/Button"
import UserSelector from "@/components/FormControl/UserSelector"

export default {
  name: "select-user-dialog",
  components: { BaseButton, BaseDialog, UserSelector },
  props: {
    title: String,
    required: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      visible: false,
      selected: [],
      selectedUser: []
    }
  },
  methods: {
    open(userIds) {
      this.selected = this._.cloneDeep(userIds) || []
      this.visible = true
    },
    submit() {
      if (this.required && this._.isEmpty(this.selected)) {
        this.$message.error("请选择人员")
        return
      }
      this.$emit("select", this.selected)
      this.$emit("select-user", this.selectedUser)
      this.visible = false
    }
  }
}
</script>

<style lang="scss" scoped>
.add-new-participant-dialog {
  .el-form {
    margin-top: 18px;
    ::v-deep {
      .el-form-item__content {
        display: flex;
        .el-select {
          flex: 1;
        }
        > span {
          flex: 1;
        }
      }
    }
  }
}
</style>
